<template>
    <v-container fluid>
        <v-layout justify-center>
            <v-flex xs12 sm10 md10>
              <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
            </v-flex>
        </v-layout>
        <TipoProcesoDialog
        :model="permiso"
        v-if="get_dialogMain.dialog && (get_dialogMain.type == 'create' || get_dialogMain.type == 'update')" />
</v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMainLocal'
import TipoProcesoDialog from '@/components/dialog/configuracion/TipoProcesoDialog'

export default {
  data: () => ({
    table: {
      singleExpand: true,
      showExpand: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'libre', hidden: '' }
        ],
        titles: [
          { text: 'Nombre', value: 'nombre', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: 'Empresa', value: 'empresa.nombre', class: 'black--text' },
          { text: '', value: 'Actions', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Nuevo Proseso', icon: 'mdi-buffer', color: 'light-green darken-2', action: 'newProcessData' }
        ],
        idDetail: true,
        detail: 'DetailProcesos'
      },
      footer: {
        paging: true
      }
    },
    permiso: {}
  }),
  components: {
    DataTableMain,
    TipoProcesoDialog
  },
  mounted () {
    this.getUrl('tipo-proceso.procesos-list')
  },
  methods: {
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getUrl('tipo-proceso.procesos-list')
    },
    newData (item) {
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 500, title: 'Nuevo Tipo Proceso' })
    },
    tableAction (item) {
      this[item.action](item)
    },
    newProcessData (item) {
    },

    ...mapActions(['getUrlServices', 'urlGetServicesActionList']),
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.urlGetServicesActionList({ url: router, data: {} })
      } else {
        this.getUrlServices()
      }
    },
    ...mapMutations(['SHOW_DIALOG_MAIN', 'CLEAR_OBJECTS'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_objects'])
  },
  watch: {
    get_urls () {
      this.getUrl('tipo-proceso.procesos-list')
    },
    get_objects (vals) {
      if (vals) {
        this.table.header.loading = false
        this.table.body.data = vals
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_OBJECTS()
  }

}
</script>

<style>

</style>
